<template>
  <div
    dir="rtl"
    class="row row-cols-1 tasks-row"
    :class="{ 'hidden-scrollbar': tasks?.filter(t => t.stoppagesAndChanges.filter(s => s.arrival.split('T')[0] === date).length)?.length <= 2 }"
    :ref="`multi-task-cell-${rowId}`"
    @click="showTasks"
    @dblclick="hideTasks"
    @mouseleave="resetCellScroll(rowId)"
  >
    <div
      dir="ltr"
      v-for="(task, index) in tasks"
      v-show="!task.archived"
      class="task-cell text-start fw-bolder rounded user-select-none"
      :class="{ 'd-none': (task.changes.length && task.stoppagesAndChanges.filter(s => s.arrival.split('T')[0] === date).length === 0) || task.stoppagesAndChanges.filter(s => s.arrival.split('T')[0] === date).length === 0, 'found-task': task.numer_Przejazdu.toLowerCase() === $parent.$parent.searchText?.toLowerCase() ?? $parent.$parent.$parent.searchText?.toLowerCase(), 'border border-1': task.numer_Przejazdu.toLowerCase() !== $parent.$parent.searchText?.toLowerCase() ?? $parent.$parent.$parent.searchText?.toLowerCase() }"
      :id="`task-cell-${task.id}-${date}-${task.vehicleId}`"
      :style="`z-index: 1;background-color: ${task?.stoppages?.filter(s => s.arrival.split('T')[0] === date)[0]?.backgroundColor ?? '#ffffff'}; color: ${task.textColor};top: ${index * 15}px;`"
      :key="`${index}-${date}-${task.id}`"
    >
      <div class="d-flex" :class="{ 'justify-content-between': task.stoppagesAndChanges.filter(s => s.arrival.split('T')[0] === date && !throughWaterAcronyms.includes(s.acronym)).length > 0, 'justify-content-end': task.stoppagesAndChanges.filter(s => s.arrival.split('T')[0] === date && !throughWaterAcronyms.includes(s.acronym)).length === 0 }">
        <TaskAcronyms :key="task" :task="task" :date="date" :vehicle-id="vehicleId" :through-water-acronyms="throughWaterAcronyms"/>
        <div class="d-flex">
          <button
            class="d-inline-block init-map-button"
            @click="initMap(task, rowId)"
            :key="task.id"
            :disabled="$store.getters['calendarTask/getDisabledMapButton']"
          >
            <i class="fa-solid fa-location-dot text-secondary"></i>
          </button>
          <button
            class="border-0"
            :id="`task-cell-button-${task.id}-${date}-${task.vehicleId}`"
            :style="`background-color: ${task.stoppages?.filter(s => s.arrival.split('T')[0] === this.date)[0]?.backgroundColor ?? '#ffffff'};`"
            data-bs-toggle="modal"
            data-bs-target="#taskEditModal"
            @click="launchTaskEditModal(task)">
            <i class="fa-solid fa-ellipsis-vertical text-secondary mx-1"></i>
          </button>
        </div>
      </div>
      <div>
        <span v-for="(comment, index) in task.comments" :key="index" role="button" class="text-xs">
          <button
            data-bs-toggle="modal"
            data-bs-target="#taskCommentModal"
            @click="launchTaskCommentModal(comment, vehicleId)"
            class="text-xs rounded-1 px-1 mr"
            :style="`background-color: ${comment.backgroundColor ?? '#ffffff'}; color: ${comment.textColor ?? '#000000'}; margin-left: 2px; font-size: 1em;`"
            v-text="comment.title"
          ></button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import emitter from '@/modules/events/emitter'
import colors from '@/modules/cells/colors'
import throughWaterAcronyms from '@/modules/map/throughWaterAcronyms'
import TaskAcronyms from '@/components/Partials/Task/TaskAcronyms.vue'

export default {
  name: 'TaskCell',
  components: { TaskAcronyms },
  props: ['tasks', 'rowId', 'vehicleId', 'date'],
  data () {
    return {
      comments: [],
      stoppagesByCurrentDate: [],
      colors: colors,
      throughWaterAcronyms: throughWaterAcronyms,
      minified: true,
      visible: true,
      disabledMapButton: false,
    }
  },
  mounted () {
    this.resetCellScroll(this.rowId)
  },
  methods: {
    launchTaskEditModal (task) {
      emitter.emit('taskEditModalRequested', { task: task, date: this.date })
    },

    launchTaskCommentModal (comment, vehicleId) {
      emitter.emit('taskCommentModalRequested', { comment: comment, vehicleId: vehicleId })
    },

    showTasks () {
      const childNodes = this.$refs[`multi-task-cell-${this.rowId}`].childNodes
      this.minified = false

      childNodes.forEach(childNode => {
        if (childNode.classList) {
          childNode.classList.remove('minified')
        }
      })
    },
    hideTasks () {
      const childNodes = this.$refs[`multi-task-cell-${this.rowId}`].childNodes
      this.minified = true

      childNodes.forEach(childNode => {
        if (childNode.classList) {
          childNode.classList.add('minified')
        }
      })
    },

    initMap (task, rowId) {
      this.$store.commit('calendarTask/setDisabledMapButton', true)
      setTimeout(() => { this.$store.commit('calendarTask/setDisabledMapButton', false) }, 2000)

      if (this.$parent.$parent.$options.name === 'Index') {
        if (this.$parent.$parent.map) {
          this.$parent.$parent.closeMapService()
        }
        this.$parent.$parent.initMapService(task, rowId, this.vehicleId)

        setTimeout(() => this.$parent.$parent.initMapService(task, rowId, this.vehicleId, false), 1000)
      } else {
        if (this.$parent.$parent.$parent.map) {
          this.$parent.$parent.$parent.closeMapService()
        }
        this.$parent.$parent.$parent.initMapService(task, rowId, this.vehicleId)

        setTimeout(() => this.$parent.$parent.$parent.initMapService(task, rowId, this.vehicleId, false), 1000)
      }
    },
    resetCellScroll (rowId) {
      this.$refs[`multi-task-cell-${rowId}`].scrollTop = this.$refs[`multi-task-cell-${rowId}`].scrollHeight
    }
  }
}
</script>

<style scoped>
.text-xs {
  font-size: .6rem;
}

.text-xl {
  font-size: 1.2rem;
}

.minified {
  height: 15px;
  overflow: hidden;
}

.init-map-button {
  background: none;
  border: none;
}

.task-cell {
  padding: 1px;
}

.hidden-scrollbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.tasks-row {
  max-height: 60px;
  overflow-y: scroll;
  --bs-gutter-x: 0;
}

.hidden-scrollbar::-webkit-scrollbar {
  display: none;
}

.found-task {
  border: 3px orangered solid;
}
</style>
